import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Typography,
  useTheme,
} from "@mui/material";
import { forwardRef, useEffect, useRef, useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import { pageConstant } from "../../../config/pageConstant";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import LiquidityRiskDashboardGrid from "../../../components/LiquidityRiskDashboardGrid";
import { serviceAPIMapping } from "../../../config/service-api-mapping";
import axios from "axios";
import moment from "moment";
import React from "react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import _ from "lodash";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import {
  appColor,
  constants,
  EndPoint,
  LemurContractFilterTabs,
  messages,
} from "../../../common/constants";
import { toast, ToastContainer } from "react-toastify";
import { mapRowId } from "../../../common/commonFunctions";
import RiskKPI from "../../../components/risk-kpi";
import RefreshIcon from "@mui/icons-material/Refresh";
import excel from "../../../assets/images/excel.svg";
import LemurDashboardCCByCPTY from "../../../components/lemur/dashboard/cc-by-cpty";
import LemurDashboardCCByTicker from "../../../components/lemur/dashboard/cc-by-ticker";
import LemurDashboardCPTYExposure from "../../../components/lemur/dashboard/cpty-exposure";
import LemurLDashboardCPTYRiskAllocUsage from "../../../components/lemur/dashboard/cpty-risk-alloc-usage";
import LemurDashboardCCByContract from "../../../components/lemur/dashboard/cc-by-contract";
import SpinnerFullScreen from "../../../components/SpinnerFullScreen";

const kpiDefaults = [
  {
    label: "Trading Book",
    typeOfData: "trading",
    isParent: true,
    value: 0,
    icon: "mdi-light:wallet",
    color: "#F4A36C",
    children: [
      {
        label: "Bal (B)",
        value: 0,
        icon: "mdi-light:wallet",
        color: "#F4A36C",
        typeOfData: "borrow_balance",
        children: [],
      },
      {
        label: "Bal (L)",
        value: 0,
        icon: "mdi-light:wallet",
        color: "#F4A36C",
        children: [],
        typeOfData: "loan_balance",
      },
      {
        label: "Borrows",
        value: 0,
        icon: "mdi-light:wallet",
        color: "#F4A36C",
        children: [],
        typeOfData: "borrows",
      },
      {
        label: "Loans",
        value: 0,
        icon: "mdi-light:wallet",
        color: "#F4A36C",
        children: [],
        typeOfData: "loans",
      },
    ],
  },
  {
    label: "Risk Capital Allocated",
    typeOfData: "risk_capital_allocated",
    value: 0,
    icon: "solar:wallet-money-bold",
    color: "#6C58CA",
    children: [],
    valueColor: "green",
  },
  {
    label: "OCC Coll",
    typeOfData: "adjustment",
    value: 0,
    icon: "icon-park-solid:adjustment",
    color: "#2867AD",
    valueColor: "#dc3545e3",
    children: [
      {
        label: "Borrow Bal",
        value: 0,
        icon: "solar:wallet-money-bold",
        color: "#2867AD",
        typeOfData: "occ_balance_l",
      },
      {
        label: "Borrow Bal",
        value: 0,
        icon: "solar:wallet-money-bold",
        color: "#2867AD",
        typeOfData: "occ_balance_b",
      },
    ],
    isParent: true,
  },

  {
    label: "Net Risk Capital",
    typeOfData: "net_risk_capital",
    value: 0,
    icon: "mdi-light:wallet",
    color: "#25BF9A",
    children: [],
    valueColor: "#dc3545e3",
  },
  {
    label: "Opening Usage",
    typeOfData: "opening_usage",
    value: 0,
    icon: "mdi:finance",
    color: "#DA7395",
    children: [],
    valueColor: "#dc3545e3",
  },
  {
    label: "Intraday Usage",
    typeOfData: "intraday_usage",
    value: 0,
    icon: "uil:money-withdrawal",
    color: "#9867BE",
    children: [],
    valueColor: "#dc3545e3",
  },
  {
    label: "Total Usage",
    typeOfData: "total_current_usage",
    value: 0,
    icon: "uil:money-withdrawal",
    color: "#3BBEE6",
    children: [],
    valueColor: "#dc3545e3",
  },
  {
    label: "Excess Risk Capital",
    typeOfData: "current_excess_risk_capital",
    value: 0,
    icon: "streamline-freehand-color:money-coin-cash",
    color: "#5ED18A",
    children: [],
    valueColor: "green",
  },
];

type SafePanelProps = {
  name: string;
  children: React.ReactNode;
};

const SafePanel: React.FC<SafePanelProps> = ({ children }) => {
  return (
    <Box
      sx={{
        height: "100%",
        minHeight: 0,
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      {children}
    </Box>
  );
};

const RiskDashboard = () => {
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [doShowFullScreenLoader, setDoShowFullScreenLoader] =
    useState<boolean>(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const [riskKPI, setRiskKPI] = useState(kpiDefaults);
  const topDivRef = useRef(null);
  const [isGridVisible, setIsGridVisible] = useState<boolean>(false);
  //   const auth = useAuth()
  const theme = useTheme();
  const [gridRef, setGridRef] = useState<any>(null);
  const [riskByTickerTop10, setRiskByTickerTop10] = useState<any>({
    legends: [],
    values: [],
  });
  const [riskByCptyTop10, setRiskByCptyTop10] = useState<any>({
    legends: [],
    values: [],
  });
  const [cptyUsageTop10, setCptyUsageTop10] = useState<any>([]);

  const [cptyExposureTop10, setCptyExposureTop10] = useState<any>([]);

  const [currentRiskPercentage, setCurrentRiskPercentage] = useState<any>(null);
  const [lastRerunAt, setLastRerunAt] = useState<any>(null);
  const accessToken = window.localStorage.getItem("refreshtoken");
   const accountId = window.localStorage.getItem("activeAccountCode");
  const [lastRefresh, setLastRefresh] = useState<any>("");

  const tabDefaultData = [
    {
      type: "Price < 2",
      avatarIcon: "tabler:shopping-cart",
      series: [{ data: [] }],
      labels: [],
    },
    {
      type: "Qty%ADTV > 10%",
      avatarIcon: "tabler:chart-bar",
      series: [{ data: [] }],
      labels: [],
    },
    {
      type: "DTL > 2",
      avatarIcon: "tabler:currency-dollar",
      series: [{ data: [] }],
      labels: [],
    },
    {
      type: "Stale Price",
      avatarIcon: "tabler:currency-dollar",
      series: [{ data: [] }],
      labels: [],
    },
    {
      type: "Qty > 5% Float",
      avatarIcon: "tabler:currency-dollar",
      series: [{ data: [] }],
      labels: [],
    },
  ];

  const [currentTabData, setCurrentTabData] = useState<any>(tabDefaultData);

  type CardSpec = {
    title: string;
    children?: React.ReactNode;
  };

  type TwoPaneNoScrollProps = {
    right?: [
      { left: CardSpec; right?: CardSpec },
      { left: CardSpec; right?: CardSpec },
      { left: CardSpec; right?: CardSpec }
    ];

    fullScreen?: boolean;

    headerHeight?: number;
  };

  const HEADER_DEFAULT = 10;

  const TwoPaneNoScroll: React.FC<TwoPaneNoScrollProps> = ({
    right,
    fullScreen = true,
    headerHeight = HEADER_DEFAULT,
  }) => {
    return (
      <Box
        className="p-0"
        sx={{
          height: fullScreen ? `calc(100vh - ${headerHeight}px)` : "100%",
          width: "100%",
          boxSizing: "border-box",
          p: 2,
          overflow: "hidden",
          display: "grid",

          gridTemplateColumns: { xs: "1fr", md: "1fr 0.7fr" },
          gridTemplateRows: { xs: "1fr 1fr", md: "1fr" },
          gap: 1,
        }}
      >
        <Box sx={{ minHeight: 0, display: "flex", flexDirection: "column" }}>
          <Card
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            <CardHeader
              sx={{
                py: 1,
                px: 2,
                borderBottom: "1px solid",
                borderColor: "divider",
                flexShrink: 0,
              }}
              title={
                <>
                  <div className="h-100 w-100">
                    <div ref={topDivRef} id="risk-by-cpty-grid" className="row">
                      <div className="col d-flex justify-content-end align-items-center flex-row">
                        <div className="d-flex flex-column text-nowrap me-3 refreshsettimedateContract">
                          <div className="time-stamp">Last re-run on: </div>
                          <div className="time-stamp">{lastRerunAt}</div>
                        </div>
                        <div className="mb-1">
                          <Button
                            className="mx-1 p-1"
                            size="small"
                            variant="contained"
                            sx={{ paddingTop: 1.5, paddingBottom: 1.5, backgroundColor: `${appColor}`, ':hover':{backgroundColor:`${appColor}`}}}
                            onClick={reCalcRiskKpi}
                            
                            
                          >
                            Re-calculate
                          </Button>
                        </div>

                        <div className="d-flex align-items-center">
                          <span
                            className="borrowExceldnld float-start"
                            onClick={onExcelExport}
                            title="Download Excel"
                          >
                            <img
                              src={excel}
                              alt=""
                              style={{
                                height: "1.8rem",
                                width: "1.8rem",
                                cursor: "pointer",
                              }}
                            />
                          </span>
                          <div
                            className="d-flex justify-content-end align-items-center cursor-pointer ms-0 pl-0"
                            onClick={refreshEvent}
                            title="Refresh Data"
                          >
                            <RefreshIcon
                              style={{
                                cursor: "pointer",
                                marginRight: "0.5rem",
                                color: "#1E355E",
                              }}
                            />
                            <div className="refreshsettimedateContract">
                              <div>Last updated on: </div>
                              <div>{lastRefresh}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              }
            />
            <CardContent
              className="pb-0"
              sx={{
                flex: 1,
                minHeight: 0,
                p: 0,
                display: "flex",
                overflow: "hidden",
              }}
            >
              <Box sx={{ flex: 1, minHeight: 0, overflow: "auto" }}>
                <SafePanel name="MainGrid">
                  <LiquidityRiskDashboardGrid
                    rowData={rowData}
                    getGridRef={() => {
                      setGridRef(gridRef);
                    }}
                    isByContractsGrid={false}
                  />
                </SafePanel>
              </Box>
            </CardContent>
          </Card>
        </Box>

        <Box
          sx={{
            minHeight: 0,
            display: "grid",
            gridTemplateRows: "repeat(3, 1fr)",
            gap: 1,
            overflow: "hidden",
          }}
        >
          {right?.map((row, i) => (
            <Box
              key={i}
              sx={{
                minHeight: 0,
                display: "grid",
                gridTemplateColumns: {
                  xs: "1fr",
                  sm: i === 2 ? "1fr" : "1fr 1fr",
                },
                gap: 1,
                alignItems: "stretch",
              }}
            >
              <SafePanel name={row.left.title}>
                <EqualHeightCard title={row.left.title}>
                  {row.left.children}
                </EqualHeightCard>
              </SafePanel>

              {i !== 2 && row?.right && (
                <SafePanel name={row.right.title ?? `${row.left.title}-right`}>
                  <EqualHeightCard title={row.right.title!}>
                    {row.right.children}
                  </EqualHeightCard>
                </SafePanel>
              )}
            </Box>
          ))}
        </Box>
        {doShowFullScreenLoader && <SpinnerFullScreen />}
      </Box>
    );
  };

  const EqualHeightCard: React.FC<
    React.PropsWithChildren<{ title: string }>
  > = ({ title, children }) => {
    return (
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <CardHeader
          className="d-flex align-items-center"
          sx={{
            py: 0,
            px: 2,
            flexShrink: 0,
            backgroundColor: "#719ece54",
          }}
          title={
            <Typography
              color={"primary"}
              className="d-flex justify-content-center"
              sx={{ fontSize: "0.85rem", fontWeight: 600, color:`${appColor}` }}
            >
              {title}
            </Typography>
          }
        />
        <CardContent
          id={title}
          className="p-0"
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            p: 2,
          }}
        >
          {children ?? (
            <Typography variant="body2" color="text.secondary">
              No content
            </Typography>
          )}
        </CardContent>
      </Card>
    );
  };

  useEffect(() => {
    setIsGridVisible(true);
  }, [topDivRef?.current]);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };

  useEffect(() => {
    getRiskKPI();
    getRiskWorkflow();
    getCPTYBorrowLimitsVsExposure();
  }, []);

  const getRiskKPI = async () => {
    try {
      setDoShowFullScreenLoader(true);

      const raw = JSON.stringify({
        function_code: "fn_rpt_get_risk_kpis",
        function_param: {
           account_id_in: accountId,
          cur_date: moment().format("YYYY-MM-DD"),
        },
      });

      const response = await axios.post(
        `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
        raw,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response) {
        setSnackbarMessage(`${messages.lemurServiceDown}`);
        return;
      }

      if (response.status === 200 && response.data) {
       const kpis = kpiDefaults?.map((kpi: any) => {
          const kpiValue: number =
            kpi?.typeOfData === "total_current_usage"
              ? (_.get(response?.data?.[0], "opening_usage") ?? 0) +
                (_.get(response?.data?.[0], "intraday_usage") ?? 0)
              : _.get(response?.data?.[0], kpi?.typeOfData, 0);

          if (
            kpi?.typeOfData === "trading" ||
            kpi?.typeOfData === "adjustment"
          ) {
            kpi.children = kpi?.children?.map((childKpi: any) => ({
              ...childKpi,
              value:_.isString(_.get(response?.data?.[0], childKpi?.typeOfData)) &&_.isEmpty(_.get(response?.data?.[0], childKpi?.typeOfData))?0: _.get(response?.data?.[0], childKpi?.typeOfData),
            }));
          }

          return {
            ...kpi,
            value:_.isString(kpiValue)&& _.isEmpty(kpiValue)?0:kpiValue,
          };
        });

        const percent = (
          (response?.data?.[0]?.adjustment +
            (response?.data?.[0]?.opening_usage +
              response?.data?.[0]?.intraday_usage)) /
          response?.data?.[0]?.risk_capital_allocated
        )?.toFixed(2);

        setCurrentRiskPercentage(Math.abs(+percent));
        setRiskKPI(kpis);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setDoShowFullScreenLoader(false);
    }
  };

  const reCalcRiskKpi = async () => {
    try {
      setDoShowFullScreenLoader(true);

      const response = await axios.put(
        `${serviceAPIMapping["LEMUR-SERVICE"].apiRouteURL}${EndPoint.workflowsRun}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response) {
        setSnackbarMessage(`${messages.lemurServiceDown}`);
        return;
      }

      if (response.status === 200 && response.data) {
        toast?.success("Re-calculated successfully, Fetching the latest data", {
          style: {
            background: `${appColor}`,
            color: "#fff",
          },
        });
      }
    } catch (error) {
      console.log("error", error);
      toast?.error("Failed to Re-calculate");
    } finally {
      setDoShowFullScreenLoader(false);
      getRiskWorkflow();
    }
  };

  const getRiskWorkflow = async () => {
    try {
      setRowData([]);
      setDoShowFullScreenLoader(true);

      const raw = JSON.stringify({
        function_code: "fn_rpt_risk_liquidity_risk_details",
      });

      const response = await axios.post(
        `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
        raw,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response) {
        setSnackbarMessage(`${messages.lemurServiceDown}`);
        return;
      }

      if (response.status === 200) {
        const rows = response?.data?.map((row: any) => ({
          ...row,
          credit_account: `${row?.name} ${row?.credit_account}`,
          parent_account: `${row?.name} ${row?.parent_account}`,
          bl: row?.direction === "LEND" ? "L" : "B",
          shares:
            isNaN(row?.shares) || _.isUndefined(row?.shares) ? 0 : +row?.shares,
          capcharge:
            isNaN(row?.capcharge) || _.isUndefined(row?.capcharge)
              ? 0
              : +row?.capcharge,
          liqrisk:
            isNaN(row?.liqrisk) || _.isUndefined(row?.liqrisk)
              ? 0
              : +row?.liqrisk,
        }));

        const mappedRows = mapRowId(rows);
        const maxLastRerun = _.maxBy(mappedRows, "last_refreshed_on");
        setLastRerunAt(maxLastRerun?.last_refreshed_on);
        setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
        setRowData([...mappedRows]);

        if (mappedRows.length > 0) {
          const cptyUsageMap: any[] = [];
          const groupByCpty = _.groupBy(mappedRows, "name");

          // CC by CPTY
          const cptyChart = Object.entries(groupByCpty).map(
            ([key, value]: [string, any[]]) => {
              const totalValue = _.sumBy(value, (v: any) =>
                _.isNumber(v.capcharge) ? v.capcharge : 0
              );
              return { legend: key, value: totalValue };
            }
          );

          const top10Cpty = _.orderBy(cptyChart, "value", "desc").slice(0, 10);
          setRiskByCptyTop10({
            legends: _.map(top10Cpty, "legend"),
            values: _.map(top10Cpty, "value"),
          });

          // CC by Ticker
          const groupByTicker = _.groupBy(mappedRows, "ticker");
          const tickerChart = Object.entries(groupByTicker).map(
            ([key, value]: [string, any[]]) => {
              const totalValue = _.sumBy(value, (v: any) =>
                _.isNumber(v.capcharge) ? v.capcharge : 0
              );
              return { legend: key, value: totalValue };
            }
          );

          const top10Ticker = _.orderBy(tickerChart, "value", "desc").slice(
            0,
            10
          );
          setRiskByTickerTop10({
            legends: _.map(top10Ticker, "legend"),
            values: _.map(top10Ticker, "value"),
          });

          // CPTY usage %
          Object.entries(groupByCpty).forEach(
            ([key, value]: [string, any[]]) => {
              const totalValue = _.sumBy(value, (v: any) =>
                _.isNumber(v.capcharge) ? v.capcharge : 0
              );

              const maxRec =  _.maxBy(
                value,
                "cpty_allcoation"
              )
              const cpty_allcoation = maxRec?.cpty_allcoation;

              const percent =
                cpty_allcoation && cpty_allcoation !== 0
                  ? ((totalValue / cpty_allcoation) * 100).toFixed(2)
                  : "0";

              cptyUsageMap.push({
                cpty_allcoation,
                cc_usage: totalValue,
                cpty: key,
                percent: +percent,
                legend: value?.[0]?.cpty_id,
                actualVal: cpty_allcoation,
                actualVal10K: cpty_allcoation / 1000,
              });
            }
          );

          const topCptyUsage = _.take(
            _.orderBy(
              cptyUsageMap.filter(
                (r: any) => r.cc_usage > 0 && r.cpty_allcoation
              ),
              "percent",
              "desc"
            ),
            7
          );

          setCptyUsageTop10(topCptyUsage);
        }
      }
    } catch (error) {
      console.log("error", error);
      setRowData([]);
    } finally {
      setDoShowFullScreenLoader(false);
    }
  };

  const getCPTYBorrowLimitsVsExposure = async () => {
    try {
      setDoShowFullScreenLoader(true);

      const raw = JSON.stringify({
        function_code: "fn_rpt_getcptybalances",
        function_param: {
          // accountid_in: auth?.user?.activeAccountCode,
          date_in: moment().format("YYYY-MM-DD"),
        },
      });

      const response = await axios.post(
        `${serviceAPIMapping["REPORTING-SERVICE"].apiRouteURL}${EndPoint.reportFn}`,
        raw,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (!response) {
        setSnackbarMessage(`${messages.lemurServiceDown}`);
        return;
      }

      if (response.status === 200) {
        const mappedRows = mapRowId(response?.data);
        const filteredRows = mappedRows?.filter(
          (s: any) => s?.borr_limit && s?.borr_exposure
        );

        const rowsInMillions = filteredRows.map((r: any) => ({
          ...r,
          bCptyMillion: r.borr_limit / 1_000_000,
          bUsageMillion: r.borr_exposure / 1_000_000,
        }));

        const usageSorted = _.orderBy(
          rowsInMillions.map((r) => ({
            ...r,
            usagePercent: (r.bUsageMillion / r.bCptyMillion) * 100,
          })),
          "usagePercent",
          "desc"
        );

        const topUsage = _.take(usageSorted, 7).map((row: any) => ({
          bCptyMillion: row.bCptyMillion,
          bUsageMillion: row.bUsageMillion,
          percent: row.usagePercent,
          legend: row.cpty_id,
          actualVal: row.bCptyMillion,
          cpty: row.cpty_name,
        }));

        setCptyExposureTop10(topUsage);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setDoShowFullScreenLoader(false);
    }
  };

  const onExcelExport = () => {
    const spreadsheets = [];
    spreadsheets.push(
      gridRef?.current?.api?.getSheetDataForExcel?.({
        sheetName: "Liquidity Risk Dashboard",
      })
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "liquidity-risk-dashboard.xlsx",
    });
  };

  const refreshEvent = () => {
    setRowData([]);
    setRiskKPI(kpiDefaults);
    getRiskKPI();
    getRiskWorkflow();
    setLastRefresh(moment(new Date()).format(constants.RefreshFormat));
  };

  const getContractsPriceLT2 = () => {
    const contracts = [...rowData];
    const priceLessThan2 = contracts?.filter((c) => c?.price < 2);
    const sortedRows = _.orderBy([...priceLessThan2], "price", "asc");

    return sortedRows;
  };

  const getContractsADTV10Days = () => {
    const contracts = [...rowData];
    const dtvPercentRows = contracts?.map((c) => {
      const adtv = c?.dtv | 0;
      const qty = c?.shares | 0;
      const dtvPercent = (qty / adtv) * 100;

      return {
        ...c,
        dtvPercent: dtvPercent,
      };
    });
    const aDTV10DaysRows = dtvPercentRows?.filter((c) => {
      const adtv = c?.dtv | 0;
      const adtv10 = adtv * 0.1;

      return c?.dtvPercent > adtv10;
    });

    const sortedRows = _.orderBy([...aDTV10DaysRows], "dtvPercent", "desc");

    return sortedRows;
  };

  const getContractsDTLGT10 = () => {
    const contracts = [...rowData];
    const dTLGT10Rows = contracts?.filter((c) => c?.daystoliquidate > 2);
    const sortedRows = _.orderBy([...dTLGT10Rows], "daystoliquidate", "desc");

    return sortedRows;
  };

  const getContractsStalePrice = () => {
    // const contracts = [...rowData]
    // const priceLessThan2 = contracts?.filter(c => c?.con_price < 2)

    return [];
  };

  const getContractsQtyGT5PercFloat = () => {
    // const contracts = [...rowData]
    // const priceLessThan2 = contracts?.filter(c => c?.shares > c?.flt * 0.05)
    // const top10 = _.take(priceLessThan2, 10)

    return [];
  };

  const getRiskByContractsBarChartInfo = async () => {
    const priceLT2Rows = await getContractsPriceLT2();
    const aDTV10DaysRows = await getContractsADTV10Days();
    const dTLGT10Rows = await getContractsDTLGT10();
    const stalePriceRows = await getContractsStalePrice();
    const qtyGT5PercFloatRows = await getContractsQtyGT5PercFloat();

    setCurrentTabData((currentTabInfo: any) => {
      const newTabInfo = [...currentTabInfo];

      let index = newTabInfo.findIndex(
        (t: any) => t.type === LemurContractFilterTabs.priceLessThan2
      );
      if (index > -1) {
        newTabInfo[index] = {
          type: LemurContractFilterTabs.priceLessThan2,
          rowData: priceLT2Rows,
        };
      }

      index = newTabInfo.findIndex(
        (t: any) => t.type === LemurContractFilterTabs.adtv10days
      );
      if (index > -1) {
        newTabInfo[index] = {
          type: LemurContractFilterTabs.adtv10days,
          rowData: aDTV10DaysRows,
        };
      }

      index = newTabInfo.findIndex(
        (t: any) => t.type === LemurContractFilterTabs.daysToLiq
      );
      if (index > -1) {
        newTabInfo[index] = {
          type: LemurContractFilterTabs.daysToLiq,
          rowData: dTLGT10Rows,
        };
      }

      index = newTabInfo.findIndex(
        (t: any) => t.type === LemurContractFilterTabs.stalePrice
      );
      if (index > -1) {
        newTabInfo[index] = {
          type: LemurContractFilterTabs.stalePrice,
          rowData: stalePriceRows,
        };
      }

      index = newTabInfo.findIndex(
        (t: any) => t.type === LemurContractFilterTabs.qtyGreaterThan5Float
      );
      if (index > -1) {
        newTabInfo[index] = {
          type: LemurContractFilterTabs.qtyGreaterThan5Float,
          rowData: qtyGT5PercFloatRows,
        };
      }

      return newTabInfo;
    });
  };

  useEffect(() => {
    setTimeout(() => {
      getRiskByContractsBarChartInfo();
    }, 200);
  }, [rowData]);

  const getRiskByContractPanel = () => {
    return (
      <>
        <LemurDashboardCCByContract data={currentTabData} />
      </>
    );
  };

  useEffect(() => {
    setTimeout(() => {
      getRiskByContractPanel();
    }, 200);
  }, [currentTabData]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <Snackbar open={open} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity="error"
          sx={{
            width: "100%",
            backgroundColor: "primary.main",
            color: "white",
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box
        sx={{
          flexShrink: 0,
          mb: 1,
          mt:1
        }}
      >
        <RiskKPI
          kpi={riskKPI}
          riskPercent={currentRiskPercentage}

        />
      </Box>

      {isGridVisible && (
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
          }}
        >
          <TwoPaneNoScroll
            fullScreen={false}
            headerHeight={0}
            right={[
              {
                left: {
                  title: "Capital Consumption (CC) by CPTY",
                  children: (
                    <Box sx={{ height: "100%" }}>
                      <LemurDashboardCCByCPTY
                        legends={riskByCptyTop10?.legends}
                        values={riskByCptyTop10?.values}
                      />
                    </Box>
                  ),
                },

                right: {
                  title: "Capital Consumption (CC) by Ticker",
                  children: (
                    <Box sx={{ height: "100%" }}>
                      <LemurDashboardCCByTicker
                        legends={riskByTickerTop10?.legends}
                        values={riskByTickerTop10?.values}
                      />
                    </Box>
                  ),
                },
              },

              {
                left: {
                  title: "Cpty Limits vs Exposure",
                  children: (
                    <Box sx={{ height: "100%" }}>
                      <LemurDashboardCPTYExposure data={cptyExposureTop10} />
                    </Box>
                  ),
                },
                right: {
                  title: "CPTY Risk Capital allocation vs usage",
                  children: (
                    <Box sx={{ height: "98%", mt: 1 }}>
                      <LemurLDashboardCPTYRiskAllocUsage
                        data={cptyUsageTop10}
                      />
                    </Box>
                  ),
                },
              },
              {
                left: {
                  title: "Risk Metrics by Contracts",
                  children: (
                    <Box sx={{ height: "100%" }}>
                      <div style={{ height: "100%" }}>
                        {getRiskByContractPanel()}
                      </div>
                    </Box>
                  ),
                },
              },
            ]}
          />
        </Box>
      )}
    </Box>
  );
};

const HEADER_HEIGHT = 79;

const LiquidityRiskDashboard = () => {
  return (
    <Box
      sx={{
        height: `calc(100vh - ${HEADER_HEIGHT}px)`,
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <RiskDashboard />
       <ToastContainer />
       
    </Box>
  );
};

LiquidityRiskDashboard.page = pageConstant.RISK_LIQUIDITY_DASHBOARD;
export default LiquidityRiskDashboard;
